import React, { useEffect, useState } from "react";
import {
  Card,
  Avatar,
  Typography,
  Space,
  Button,
  Row,
  Col,
  Divider,
  Drawer,
  Form,
  Input,
  Tag,
  Dropdown,
  Select,
  DatePicker,
  Modal,
  Empty,
} from "antd";
import {
  DownOutlined,
  EditOutlined,
  CloseCircleOutlined,
  PlusCircleOutlined,
  CheckCircleOutlined,
  DeleteOutlined,
  MoreOutlined,
  ClockCircleOutlined,
  UserOutlined,
  PhoneFilled,
  PhoneOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteLeadCallByIdAPI,
  editLeadCallAPI,
  getLeadCallByIdAPI,
  getLeadCallsListAPI,
  saveLeadCallAPI,
} from "../LeadsAPI";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import {
  getEmployeeAPI,
  getStatusAPI,
} from "CommonComponents/Lookup/LookupAPI";
import { FormattedMessage, useIntl } from "react-intl";
import { resetLeadCallById, setLeadCallsList } from "../LeadsSlice";
import InfiniteScroll from "react-infinite-scroller";

function CallsTab() {
  const { Text } = Typography;
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  dayjs.extend(utc);
  const { leadId } = useParams();
  const intl = useIntl();
  const selectedLanguage = localStorage.getItem("selectedlanguage") || "fr-FR";
  const [open, setOpen] = useState(false);
  const [editingCallId, setEditingCallId] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const leadCallsList = useSelector((state) => state.leads.leadCallList);
  const statusList = useSelector((state) => state.lookup.statusList);
  const employeeList = useSelector((state) => state.lookup.employesList);
  const leadCallById = useSelector((state) => state.leads.leadCallById);
  const createdDate = Form.useWatch("createdDate", form);

  useEffect(() => {
    dispatch(getStatusAPI());
    dispatch(getEmployeeAPI());
  }, [dispatch]);
  const showDrawer = (call = null) => {
    setOpen(true);
    setEditingCallId(call?.id || null);
    if (call) {
      form.setFieldsValue({
        createdDate: dayjs(),
      });
    } else {
      form.resetFields();
    }
  };
  const onClose = () => {
    setOpen(false);
    setEditingCallId(null);
    form.resetFields();
    dispatch(resetLeadCallById());
  };
  const values = {
    pageNo: page,
    pageSize: 10,
    searchQuery: "",
  };
  const loadMoreData = (explicitPage) => {
    const currentPage = explicitPage || page;
    if (loading || !hasMore) return;
    setLoading(true);

    dispatch(getLeadCallsListAPI(leadId, values))
      .then((res) => {
        const items = res?.payload?.items || [];
        const totalPages = res?.payload?.totalPages;
        const currentPage = res?.payload?.pageNumber;

        if (currentPage >= totalPages || items.length === 0) {
          setHasMore(false);
        } else {
          setPage((prev) => prev + 1);
        }
      })
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    if (leadId) {
      setPage(1);
      setHasMore(true);
      dispatch(setLeadCallsList({ items: [], pageNumber: 1 }));
      loadMoreData(1);
    }
  }, [leadId]);
  useEffect(() => {
    if (editingCallId && leadCallById?.id === editingCallId) {
      form.setFieldsValue({
        callStatusId: leadCallById.callStatusId,
        followUpDate: leadCallById.followUpDate
          ? dayjs(leadCallById.followUpDate)
          : null,
        note: leadCallById.note,
      });
    }
  }, [leadCallById, editingCallId, form]);

  const getEmployeeNameById = (employeeId) => {
    const employee = employeeList.find((item) => item.id === employeeId);
    return employee
      ? `${employee.firstName} ${employee.lastName}`
      : "Unknown User";
  };
  const statusMap = {
    8: { color: "#d46b08", label: "No Answer" },
    9: { color: "#52c41a", label: "Call Completed" },
    10: { color: "#faad14", label: "Follow-up Required" },
    11: { color: "#1677ff", label: "Voicemail Left" },
    12: { color: "#ff4d4f", label: "Busy/Line Engaged" },
  };

  const handleSubmit = (values) => {
    const leadCallObj = {
      id: editingCallId || 0,
      leadId: leadId,
      createdDate: values.createdDate,
      callStatusId: values.callStatusId,
      followUpDate: values.followUpDate
        ? dayjs(values.followUpDate).format("YYYY-MM-DD")
        : null,
      note: values.note,
    };
    if (leadCallById?.id) {
      dispatch(editLeadCallAPI(leadCallObj, leadId, values)).then(() => {
        setOpen(false);
        form.resetFields();
        dispatch(resetLeadCallById());
        setEditingCallId(null);
      });
    } else {
      dispatch(saveLeadCallAPI(leadCallObj, leadId, values)).then(() => {
        form.resetFields();
        dispatch(resetLeadCallById());
        setOpen(false);
        setEditingCallId(null);
      });
    }
  };
  const handleEdit = (call) => {
    setEditingCallId(call.id);
    dispatch(getLeadCallByIdAPI(call.id));
    showDrawer(call);
  };
  const handleDelete = (callId) => {
    Modal.confirm({
      title: intl.formatMessage({ id: "LeadCall.DeleteConfirm" }),
      okText: intl.formatMessage({ id: "Common.Yes" }),
      okType: "danger",
      cancelText: intl.formatMessage({ id: "Common.No" }),
      onOk() {
        dispatch(deleteLeadCallByIdAPI(callId, leadId, values));
      },
    });
  };
  const items2 = (call) => [
    {
      label: (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleEdit(call);
          }}
        >
          <EditOutlined />
          &nbsp;&nbsp;
          <FormattedMessage id="Common.Edit" />
        </a>
      ),
      key: "0",
    },

    {
      label: (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleDelete(call.id);
          }}
        >
          <DeleteOutlined />
          &nbsp;&nbsp;
          <FormattedMessage id="Common.Delete" />
        </a>
      ),
      key: "1",
    },
  ];

  return (
    <>
      <div className="notes-btn">
        <Button
          color="primary"
          variant="dashed"
          block
          className="mb-10 new-btn-add"
          onClick={showDrawer}
        >
          <PlusCircleOutlined />
          {<FormattedMessage id="LeadCall.AddNew" />}
        </Button>
        <div style={{ maxHeight: "60vh", overflow: "auto" }}>
          <InfiniteScroll
            pageStart={1}
            loadMore={() => page > 1 && loadMoreData()}
            hasMore={!loading && hasMore}
            useWindow={false}
            threshold={100}
            loader={
              <div
                key="loader"
                style={{ textAlign: "center", padding: "1rem" }}
              >
                {<FormattedMessage id="Common.loading" />}
              </div>
            }
          >
            <Space direction="vertical" size={10} style={{ width: "100%" }}>
              {leadCallsList?.length > 0 ? (
                leadCallsList.map((call) => {
                  const status = statusMap[call.callStatusId];
                  return (
                    <Card
                      key={call.id}
                      className="activitytab"
                      style={{ width: "100%" }}
                      //style={{ width: "100%", maxWidth: "800px" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: "16px",
                          width: "100%",
                        }}
                      >
                        <Space align="start">
                          <Avatar
                            shape="square"
                            size={32}
                            icon={
                              <PhoneOutlined style={{ color: "#09979e" }} />
                            }
                            style={{
                              background: "#e1fafa",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          />
                          <div>
                            <Text strong>{call.title}</Text>
                            <p>{call.note}</p>
                            {call.followUpDate && (
                              <Tag
                                color="orange"
                                icon={<ClockCircleOutlined />}
                                style={{
                                  fontWeight: "bold",
                                  border: "1px solid #ffa940",
                                  boxShadow: "0 0 4px rgba(255,169,64,0.3)",
                                }}
                              >
                                <FormattedMessage id="LeadCall.Follow" />:{" "}
                                {dayjs(call.followUpDate).format("DD MMM YYYY")}
                              </Tag>
                            )}
                            {status && (
                              <Tag color={status.color}>
                                {selectedLanguage === "fr-FR"
                                  ? statusList.find(
                                      (s) => s.id === call.callStatusId
                                    )?.nameFr
                                  : status.label}
                              </Tag>
                            )}
                            <Text
                              type="secondary"
                              strong
                              className="username-new mt-10 f-11"
                            >
                              <FormattedMessage id="LeadCall.LoggedDate" />{" "}
                              {getEmployeeNameById(call.createdBy)}
                              ,&nbsp;&nbsp;&nbsp;
                              {dayjs(call.createdDate).format(
                                "DD MMM YYYY, hh:mm a"
                              )}
                            </Text>
                          </div>
                        </Space>
                        <div className="activitytab-dropdown">
                          <Dropdown
                            menu={{ items: items2(call) }}
                            trigger={["click"]}
                          >
                            <Button
                              onClick={(e) => e.preventDefault()}
                              icon={<MoreOutlined />}
                            />
                          </Dropdown>
                        </div>
                      </div>
                    </Card>
                  );
                })
              ) : (
                <Card className="text-center">
                  <Empty description={false} />
                  <Text type="secondary">
                    {<FormattedMessage id="NoData" />}
                  </Text>
                </Card>
              )}

              {!hasMore && leadCallsList?.length > 0 && (
                <div
                  style={{
                    textAlign: "center",
                    padding: "0",
                    color: "#999",
                  }}
                >
                  {<FormattedMessage id="Common.EndOfList" />}
                </div>
              )}
            </Space>
          </InfiniteScroll>
        </div>

        <Drawer
          title={
            editingCallId ? (
              <FormattedMessage id="AddLeadCall.EditCallLog" />
            ) : (
              <FormattedMessage id="AddLeadCall.CreateCallLog" />
            )
          }
          onClose={onClose}
          destroyOnClose
          open={open}
          width="500px"
        >
          <Form
            name="basic"
            form={form}
            layout="vertical"
            autoComplete="off"
            size="large"
            onFinish={handleSubmit}
          >
            <Form.Item
              label={<FormattedMessage id="AddLeadCall.ContactedDate" />}
              name="createdDate"
              // rules={[
              //   {
              //     required: true,
              //   },
              // ]}
            >
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item
              label={<FormattedMessage id="AddLeadCall.CallStatus" />}
              name="callStatusId"
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "AddLeadCall.Error.CallStatus",
                  }),
                },
              ]}
            >
              <Select
                placeholder={intl.formatMessage({
                  id: "AddLeadCall.Placeholder.SelectStatus",
                })}
                optionFilterProp="label"
              >
                {statusList
                  ?.filter((status) => status.id > 7)
                  .map((status) => (
                    <Select.Option key={status.id} value={status.id}>
                      {
                        status[
                          `name${selectedLanguage === "fr-FR" ? "Fr" : "En"}`
                        ]
                      }
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              label={<FormattedMessage id="AddLeadCall.FollowUp" />}
              name="followUpDate"
              // rules={[
              //   {
              //     required: true,
              //   },
              // ]}
            >
              <DatePicker
                placeholder={intl.formatMessage({
                  id: "AddLeadCall.Placeholder.SelectDate",
                })}
                style={{ width: "100%" }}
                disabledDate={(current) => {
                  if (!createdDate) return false;
                  return (
                    current &&
                    current.isBefore(dayjs(createdDate).startOf("day"))
                  );
                }}
              />
            </Form.Item>
            <Form.Item
              label={<FormattedMessage id="AddLeadCall.Note" />}
              name="note"
              // rules={[
              //   {
              //     required: true,
              //   },
              // ]}
            >
              <TextArea
                rows={4}
                placeholder={intl.formatMessage({
                  id: "AddLeadCall.Placeholder.EnterNotes",
                })}
                maxLength={255}
                showCount
              />
            </Form.Item>

            <Row>
              <Col span={24} className="text-center mt-10">
                <Space>
                  <Button
                    danger
                    variant="outlined"
                    size="medium"
                    onClick={onClose}
                  >
                    <CloseCircleOutlined />{" "}
                    {<FormattedMessage id="Common.Cancel" />}
                  </Button>
                  <Button type="primary" size="medium" htmlType="submit">
                    <CheckCircleOutlined />
                    {<FormattedMessage id="Common.Save" />}
                  </Button>
                </Space>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </div>
    </>
  );
}

export default CallsTab;
